export const SourceOfLogin = {
  ORDER: 'ORDER',
  POSTBOOKING: 'POSTBOOKING',
  MODAL: 'MODAL',
  CONTACTUS: 'CONTACTUS',
  RYANAIR: 'RYANAIR',
} as const;
export type SourceOfLoginType = (typeof SourceOfLogin)[keyof typeof SourceOfLogin];
